export default function Card({

    children,

    className="",

    hover=true,

    padding="lg"

}){

    return(

        <div

            className={`
                crm-card
                crm-card-${padding}
                ${hover?"crm-card-hover":""}
                ${className}
            `}

        >

            {children}
<style>{`.crm-card{

    background:#FFFFFF;

    border:1px solid #E5E7EB;

    border-radius:18px;

    padding:20px;

    box-shadow:

        0 2px 6px rgba(15,23,42,.04);

    transition:.2s ease;

}

.crm-card:hover{

    border-color:#CBD5E1;

    box-shadow:

        0 10px 30px rgba(15,23,42,.08);

    transform:translateY(-2px);

}
.crm-lead-header{

    display:flex;

    justify-content:space-between;

    align-items:flex-start;

    gap:16px;

    margin-bottom:20px;

}

.crm-lead-user{

    display:flex;

    gap:14px;

    align-items:center;

}

.crm-lead-info h3{

    margin:0;

    font-size:18px;

    color:#0F172A;

}

.crm-lead-info p{

    margin-top:4px;

    color:#64748B;

    font-size:14px;

}

.crm-lead-loan{

    margin:20px 0;

}

.crm-loan-type{

    display:flex;

    align-items:center;

    gap:8px;

    color:#64748B;

    font-size:14px;

}

.crm-loan-amount{

    margin-top:10px;

    font-size:30px;

    font-weight:700;

    color:#2563EB;

}

.crm-info-grid{

    display:grid;

    grid-template-columns:repeat(2,1fr);

    gap:16px;

    margin-bottom:20px;

}

.crm-info-item{

    display:flex;

    flex-direction:column;

    gap:4px;

}

.crm-info-item label{

    font-size:12px;

    color:#94A3B8;

    text-transform:uppercase;

    letter-spacing:.05em;

}

.crm-info-item span{

    font-size:14px;

    color:#334155;

    font-weight:500;

}

.crm-card-actions{

    display:flex;

    justify-content:flex-end;

    gap:10px;

}`}</style>
        </div>

    );

}